var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gc-main-layout',{attrs:{"title":_vm.title,"isXSmall":_vm.isXSmall,"isLarge":_vm.isLarge}},[_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }